import { AnyAction } from "redux";
import { MODULE_NAME } from "../moduleName";
import { User } from "../services/domain/User";
import {
  PagedResponse,
  QueryParams,
  JSONPatchDocument,
} from "@ofqual/portal-core/core/types";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_USERS = `${MODULE_NAME}/LOADED_USERS`;
export const LOADING_USERS = `${MODULE_NAME}/LOADING_USERS`;

export const LOADED_USER = `${MODULE_NAME}/LOADED_USER`;
export const LOADING_USER = `${MODULE_NAME}/LOADING_USER`;
export const SAVED_USER = `${MODULE_NAME}/SAVED_USER`;

export const UPDATING_USER = `${MODULE_NAME}/UPDATING_USER`;
export const UPDATING_USER_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_USER_VALIDATION_FAIL`;
export const CREATING_USER = `${MODULE_NAME}/CREATING_USER`;
export const CREATING_USER_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_USER_VALIDATION_FAIL`;
export const CREATED_USER = `${MODULE_NAME}/CREATED_USER`;

export const ACTIVATING_USER = `${MODULE_NAME}/ACTIVATING_USER`;

export const RESETTING_PASSWORD = `${MODULE_NAME}/RESETTING_PASSWORD`;

export const loadedUsers = (payload: PagedResponse<User>) => ({
  type: LOADED_USERS,
  payload,
});
export const loadingUsers = (payload: QueryParams) => ({
  type: LOADING_USERS,
  payload,
});

export const loadedUser = (user: User) => ({
  type: LOADED_USER,
  payload: user,
});

export const savedUser = (user: User) => ({
  type: SAVED_USER,
  payload: user,
});

export const loadingUser = (upn: string) => ({
  type: LOADING_USER,
  payload: upn,
});

export const updateUser = (upn: string, patchDocument: JSONPatchDocument) => ({
  type: UPDATING_USER,
  payload: { upn, patchDocument },
});

export const createUser = (user: User) => ({
  type: CREATING_USER,
  payload: user,
});

export const deactivateUser = (upn: string) => ({
  type: ACTIVATING_USER,
  payload: { upn, active: true },
});

export const reactivateUser = (upn: string) => ({
  type: ACTIVATING_USER,
  payload: { upn, active: false },
});

export const resettingPassword = (upn: string) => ({
  type: RESETTING_PASSWORD,
  payload: { upn },
});
